<script setup lang="ts">
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from "reka-ui";
import { ref, watch } from "vue";

const modelValue = defineModel<[number, number]>({ required: true });
withDefaults(defineProps<{ min: number; max: number; step?: number; suffix?: string }>(), { step: 1 });
const proxy = ref<[number, number]>(modelValue.value);
function onValueCommit() {
  modelValue.value = proxy.value;
}
watch(modelValue, (newValue) => proxy.value = newValue);
</script>

<template>
  <SliderRoot
    v-model="proxy"
    :default-value="[min, max]"
    :min="min"
    :max="max"
    :step="step"
    :min-steps-between-thumbs="1"
    class="relative flex h-6 w-full touch-none select-none items-center"
    @value-commit="onValueCommit"
  >
    <SliderTrack class="relative h-2 grow rounded-full bg-muted">
      <SliderRange class="absolute h-full rounded-full bg-primary" />
    </SliderTrack>
    <SliderThumb class="focus-default block size-6 rounded-full bg-primary" aria-label="Minimum" />
    <SliderThumb class="focus-default block size-6 rounded-full bg-primary" aria-label="Maximum" />
  </SliderRoot>
  <div class="text-center font-semibold">
    {{ proxy[0] }} - {{ proxy[1] }} <span v-if="suffix">{{ suffix }}</span>
  </div>
</template>
